import { siteInfo } from "@/mocks/content";

const items = [
  {
    icon: "ri-phone-line",
    label: "电话咨询",
    value: siteInfo.phone,
    href: `tel:${siteInfo.phone}`,
    hint: "点击拨打",
  },
  {
    icon: "ri-mail-line",
    label: "邮箱联系",
    value: siteInfo.email,
    href: `mailto:${siteInfo.email}`,
    hint: "点击发送邮件",
  },
  {
    icon: "ri-map-pin-line",
    label: "品牌地址",
    value: siteInfo.address,
    hint: null,
  },
  {
    icon: "ri-time-line",
    label: "工作时间",
    value: siteInfo.workTime,
    hint: null,
  },
];

export default function ContactInfo() {
  return (
    <div className="bg-background-50 border border-background-200 rounded-lg p-6 md:p-8">
      <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground-950 mb-6">
        联系方式
      </h3>
      <div className="flex flex-col gap-5">
        {items.map((item) => {
          const content = (
            <div className="flex items-start gap-4">
              <span className="w-11 h-11 shrink-0 flex items-center justify-center rounded-md bg-primary-50 text-primary-600">
                <i className={`${item.icon} text-lg`}></i>
              </span>
              <div className="min-w-0">
                <p className="text-xs text-foreground-500">{item.label}</p>
                <p className="mt-0.5 text-sm md:text-base text-foreground-900 leading-relaxed break-words">
                  {item.value}
                </p>
                {item.hint && <p className="mt-0.5 text-xs text-accent-700">{item.hint}</p>}
              </div>
            </div>
          );

          return item.href ? (
            <a
              key={item.label}
              href={item.href}
              className="hover:bg-background-100 rounded-md -mx-2 px-2 py-1.5 transition-colors cursor-pointer"
            >
              {content}
            </a>
          ) : (
            <div key={item.label} className="-mx-2 px-2 py-1.5">
              {content}
            </div>
          );
        })}
      </div>
    </div>
  );
}